module.exports = __webpack_public_path__ + "img/gray-ratio3x2.3a971813.png";